import { FileItemProps } from "../../types";

export const useFileItemA11y = ({ index }: Pick<FileItemProps, "index">) => {
  const downloadButtonIndex = index > 0 ? index + index : 0;

  return {
    downloadButtonIndex,
    removeButtonIndex: downloadButtonIndex + 1,
  };
};
